document.addEventListener("DOMContentLoaded", () => {
  // SMS Newsletter Form (US users)
  const smsForm = document.querySelector("#sms-newsletter-form");
  const phoneInput = document.querySelector("#phone-input");

  // Email Newsletter Form (Non-US users)
  const emailForm = document.querySelector("#email-newsletter-form");
  const emailInput = document.querySelector("#email-input");

  // Shared Newsletter Messages
  const newsletterSuccessMessage = document.getElementById("newsletter-success");
  const newsletterErrorMessage = document.getElementById("newsletter-error");
  const newsletterErrorText = document.getElementById("newsletter-error-text");

  // Initialize SMS form if it exists
  if (smsForm && phoneInput) {
    initializeSMSForm();
  }

  // Initialize Email form if it exists
  if (emailForm && emailInput) {
    initializeEmailForm();
  }

  function initializeSMSForm() {
    // Remove any existing onsubmit attributes
    smsForm.removeAttribute("onsubmit");

    // Add phone number formatting
    phoneInput.addEventListener("input", formatPhoneNumber);
    phoneInput.addEventListener("keydown", handlePhoneKeydown);

    // Form submission
    smsForm.addEventListener("submit", handleSMSSubmit);

    phoneInput.addEventListener("input", clearErrors);
  }

  function initializeEmailForm() {
    emailForm.addEventListener("submit", handleEmailSubmit);

    emailInput.addEventListener("input", clearErrors);
  }

  function formatPhoneNumber(event) {
    const input = event.target;

    // Get only the digits from the current value
    const value = input.value.replace(/\D/g, "");

    // Format progressively - only add formatting when digits are actually present
    let formattedValue = "";

    if (value.length === 0) {
      formattedValue = "";
    } else if (value.length <= 3) {
      // (123
      formattedValue = `(${value}`;
    } else if (value.length <= 6) {
      // (123) 456
      formattedValue = `(${value.slice(0, 3)}) ${value.slice(3)}`;
    } else {
      // (123) 456-7890
      formattedValue = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
    }

    // Update the input value
    input.value = formattedValue;
  }

  function handlePhoneKeydown(event) {
    // Allow backspace, delete, tab, escape, enter
    if (
      [8, 9, 27, 13, 46].indexOf(event.keyCode) !== -1 ||
      // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      (event.keyCode === 65 && event.ctrlKey === true) ||
      (event.keyCode === 67 && event.ctrlKey === true) ||
      (event.keyCode === 86 && event.ctrlKey === true) ||
      (event.keyCode === 88 && event.ctrlKey === true)
    ) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((event.shiftKey || event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
      event.preventDefault();
    }
  }

  async function handleSMSSubmit(event) {
    event.preventDefault();

    const phone = phoneInput.value.trim();
    const cleanPhone = phone.replace(/\D/g, "");

    if (!phone) {
      showError("Please enter a phone number.", phoneInput);
      return;
    }

    if (!validatePhone(cleanPhone)) {
      showError("Please enter a valid 10-digit phone number.", phoneInput);
      return;
    }

    // Post to the back-end proxy (sms_subscribe_endpoint theme setting). The proxy
    // holds the Postscript API key server-side and forwards to Postscript with the
    // numeric Keyword ID — no credentials are ever sent from the browser.
    // NOTE: read the attribute, not smsForm.action — with no action attribute the
    // property resolves to the current page URL, which would post to the wrong place.
    const endpoint = smsForm.getAttribute("action");
    if (!endpoint) {
      console.warn(
        "[Footer SMS] sms_subscribe_endpoint theme setting is not configured — see scripts/bww-middleware/README.md"
      );
      showError("Unable to subscribe at this time, try again later.", phoneInput);
      return;
    }

    const payload = {
      phone_number: cleanPhone,
      // API v2 keyword ID for JOINBRUNT (from GET /api/v2/keywords). The dashboard
      // URL shows 397454, but the API rejects that internal ID with "Not Found" —
      // it requires this kw_… identifier.
      keyword_id: "kw_2f2c13fa3003a48d", // gitleaks:allow — public keyword id, not a credential (browser-visible by design)
      origin: "website",
    };

    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        showSuccess("Thanks for subscribing!<br>We'll send you a message shortly.");
      } else {
        throw new Error("Subscription failed");
      }
    } catch {
      showError("Unable to subscribe at this time, try again later.", phoneInput);
    }
  }

  async function handleEmailSubmit(event) {
    event.preventDefault();

    const email = emailInput.value.trim();

    if (!email) {
      showError("Please enter an email address.", emailInput);
      return;
    }

    if (!validateEmail(email)) {
      showError("Please enter a valid email address.", emailInput);
      return;
    }

    const submitBtn = emailForm.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.innerHTML = "Signing&nbsp;Up...";
    submitBtn.disabled = true;

    // Post to the BWW middleware (form action). It holds the Klaviyo list id
    // server-side and rate-limits the endpoint, so the browser sends only the
    // email address. Read the attribute, not emailForm.action — with no action
    // attribute the property resolves to the current page URL.
    const endpoint = emailForm.getAttribute("action");
    if (!endpoint) {
      console.warn(
        "[Footer email] middleware_base_url theme setting is not configured — see scripts/bww-middleware/README.md"
      );
      showError("Something went wrong. Please try again.", emailInput);
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
      return;
    }

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json().catch(() => ({}));

      if (data.success) {
        showSuccess("Thanks for subscribing!<br>We'll send you a message shortly.");
        emailForm.reset();
      } else {
        showError(data.message || "Something went wrong. Please try again.", emailInput);
      }
    } catch (error) {
      console.error("Email subscription error:", error);
      showError("Something went wrong. Please try again.", emailInput);
    } finally {
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    }
  }

  function validatePhone(phone) {
    // US phone number validation (10 digits)
    const phoneRegex = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;
    return phoneRegex.test(phone);
  }

  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function showError(message, inputElement) {
    if (newsletterErrorMessage && newsletterErrorText) {
      newsletterSuccessMessage.classList.add("hidden");
      newsletterErrorText.textContent = "";
      newsletterErrorMessage.classList.remove("hidden");
      newsletterErrorMessage.classList.add("flex");

      requestAnimationFrame(() => {
        newsletterErrorText.textContent = message;
        if (inputElement) {
          inputElement.setAttribute("aria-invalid", "true");
          inputElement.focus();
        }
      });
    }
  }

  function showSuccess(message) {
    if (newsletterSuccessMessage) {
      newsletterSuccessMessage.innerHTML = message;
      newsletterSuccessMessage.classList.remove("hidden");
      newsletterErrorMessage.classList.remove("flex");
      newsletterErrorMessage.classList.add("hidden");
    }
    if (smsForm) smsForm.classList.add("hidden");
    if (emailForm) emailForm.classList.add("hidden");
    clearErrors();
  }

  function clearErrors() {
    if (newsletterErrorMessage) {
      newsletterErrorMessage.classList.add("hidden");
      newsletterErrorMessage.classList.remove("flex");
    }
    phoneInput?.removeAttribute("aria-invalid");
    emailInput?.removeAttribute("aria-invalid");
  }
});
